import { TokenExAutoFillValues, useTokenEx } from '../TokenEx';
import { AgreeToTerms } from './AgreeToTerms';
import { Disclaimer } from './Disclaimer';
import { Fields } from './Fields';
import { TokenFormProvider, useTokenExForm, useUserTokenExFormContext } from './FormContext';
import { Logo } from './Logo';
import { SubmitButton } from './SubmitButton';
import { useTokenize } from './useTokenize';

const FormErrors = {
  name: 'Full Name is required',
  terms: 'You must agree to the terms',
  month: 'Month must be 2 digits 01-12',
  year: 'Year must be 4 digits',
  zip: 'Zip code must be 5 or more digits',
  card: 'Invalid Card',
  isCardValid: 'Invalid Card',
} as const;

const formatAutoFill = (autoFillValues: TokenExAutoFillValues) => {
  const { nameOnCard, cardExp } = autoFillValues;

  const [month, year] = cardExp.split('/');

  return { nameOnCard, month, year };
};
// Step 1: De-couple original mono
// Step 2: Integrate Mantine form to create a re-useable TokenEx Instance
// Step 3: Refactor Existing components that should be using TokenEx
// Step 4: Create  a Performant Form Context that does NOT subscribe all components

const TokenEx = {
  Fields,
  AgreeToTerms,
  Provider: TokenFormProvider,
  useUserTokenExFormContext,
  useTokenExForm,
  useTokenization: useTokenEx,
  Logo: Logo,
  SubmitButton,
  FormErrors,
  formatAutoFill,
  useTokenize,
  Disclaimer,
} as const;

export { TokenEx };
